import { atom } from "jotai";
import moment from "moment";

export const formInstanceAtom = atom(undefined);
export const fechaSeleccionadaAtom = atom(moment());
// export const colaboradoresAtom = atom([]);
export const solicitudesAtom = atom([]);
// export const totalColaboradoresAtom = atom(0);
// export const paginaAtom = atom(0);